export function buildBrandingQueryV1(organizationUnitId: number)
{
	return {
		'$type': 'TCh.Domain.Organizations.OrganizationUnits.Queries.BrandingQueryV1, TCh.Domain.Organizations',
		'OrganizationUnitId': organizationUnitId,
	}
}

export function buildInstanceSetupQueryV1()
{
	return {
		'$type': 'TCh.Domain.Organizations.OrganizationUnits.Queries.InstanceSetupQueryV1, TCh.Domain.Organizations',
	}
}

export function buildOrganizationAdminDetailsQueryV1(tenantId: number)
{
	return {
		'$type': 'TCh.Domain.Organizations.OrganizationUnits.Queries.OrganizationAdminDetailsQueryV1, TCh.Domain.Organizations',
		'TenantId': tenantId,
	}
}

export function buildOrganizationUnitQueryV1(organizationUnitId: number)
{
	return {
		'$type': 'TCh.Domain.Organizations.OrganizationUnits.Queries.OrganizationUnitQueryV1, TCh.Domain.Organizations',
		'OrganizationUnitId': organizationUnitId,
	}
}

export function buildOrganizationUnitsQueryV1()
{
	return {
		'$type': 'TCh.Domain.Organizations.OrganizationUnits.Queries.OrganizationUnitsQueryV1, TCh.Domain.Organizations',
	}
}

export function buildSearchOrganizationUnitQueryV1(organizationUnitId: number, searchPhrase: string)
{
	return {
		'$type': 'TCh.Domain.Organizations.OrganizationUnits.Queries.SearchOrganizationUnitQueryV1, TCh.Domain.Organizations',
		'OrganizationUnitId': organizationUnitId,
		'SearchPhrase': searchPhrase,
	}
}

export function buildSsoConfigurationQueryV1(tenantId: number)
{
	return {
		'$type': 'TCh.Domain.Organizations.OrganizationUnits.Queries.SsoConfigurationQueryV1, TCh.Domain.Organizations',
		'TenantId': tenantId,
	}
}

export function buildSystemStatsQueryV1()
{
	return {
		'$type': 'TCh.Domain.Organizations.OrganizationUnits.Queries.SystemStatsQueryV1, TCh.Domain.Organizations',
	}
}

